import { NgModule } from '@angular/core';
import { FormatTrackingTimezonePipe } from './format-tracking-timezone.pipe';

@NgModule({
  declarations: [FormatTrackingTimezonePipe],
  exports: [FormatTrackingTimezonePipe],
})
export class FormatTrackingTimezonePipeModule {}
